import { sendEvent, sendException } from 'helpers/analytics';
import { getChannelContextCode, getJsonStringify } from 'helpers/Utility';
import { setError, setHomePath, setIsLogin, setOauthToken } from 'store/actions/auth';
import { setApplicationStatus } from 'store/actions/loanApply';

/**
 * to handle error application inquiry status
 * @param {*} dispatch
 * @param {*} err
 * @param {*} auth
 * @param {*} params
 * @returns
 */
export const handleApplicationError = (dispatch, err, auth, params) => {
  if (err.response) {
    if (err.response.status === 401) dispatch(setError(''));
  } else {
    dispatch(setError('connection'));
    dispatch(setOauthToken('', ''));
    dispatch(setIsLogin(false));
    return;
  }

  const errorCode = getChannelContextCode(err, 'channel-context');
  if (errorCode === null) {
    dispatch(setError('system'));
    dispatch(setOauthToken('', ''));
    dispatch(setIsLogin(false));
    return;
  }

  if (errorCode === '8504') {
    dispatch(setHomePath('/home'));
    dispatch(setApplicationStatus(''));
    params?.empty?.();
    return;
  }

  if (errorCode === '14084') {
    dispatch(setError('contact-cs'));
    dispatch(setOauthToken('', ''));
    return;
  }
  if (errorCode === '995000') {
    dispatch(setError('eod'));
    params?.empty
      ? params.empty()
      : params?.actionEndOfDay?.({
          rayanetEndOfDay: 'Y',
          applicationStatus: { cmCode: 'APP_EXPIRED' }
        });
    return;
  }

  dispatch(setError('system'));
  dispatch(setOauthToken('', ''));
  dispatch(setIsLogin(false));

  sendEvent({
    category: 'Unexpected Error Application Status',
    action: getJsonStringify(err.response),
    label: auth.phoneNo
  });
  sendException({ desc: getJsonStringify(err.response), fatal: true });
};
